import { render, staticRenderFns } from "./decorationStatistics.vue?vue&type=template&id=51072402&scoped=true&"
import script from "./decorationStatistics.vue?vue&type=script&lang=js&"
export * from "./decorationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./decorationStatistics.vue?vue&type=style&index=0&id=51072402&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51072402",
  null
  
)

export default component.exports